(function () {
  'use strict';

  /* ═══════════════════════════════════════
     i18n
  ═══════════════════════════════════════ */
  var _i18n = window.wsI18n || {};

  function t(key, data) {
    var defaults = {
      countOne:        '1 saved product',
      countOther:      '{{count}} saved products',
      emptyTitle:      'Your wishlist is empty',
      emptySubtitle:   'Save your favourite items here.',
      addToCart:       'Add to cart',
      added:           '\u2713 Added',
      error:           'Error',
      errorGeneric:    'This item could not be added to the cart.',
      remove:          'Remove from wishlist',
      qty:             'Qty',
      qtyDecrease:     'Decrease quantity',
      qtyIncrease:     'Increase quantity',
      shareLinkCopied: '\u2713 Link copied!',
      shareTitle:      'My wishlist',
      loading:         'Loading...',
      loginRequired:   'To add products to your wishlist, please sign in to your account first.',
      loginRequiredButton: 'Sign in',
      emptyCatNewArrivals: 'New Arrivals',
      emptyCatSwimwear: 'Swimwear',
      emptyCatTshirts: 'T-Shirts',
      emptyCatJeans: 'Jeans',
      emptyCatSets: 'Sets',
      emptyCatPolos: 'Polos'
    };

    var str = _i18n[key] !== undefined ? _i18n[key] : (defaults[key] || key);

    if (data) {
      Object.keys(data).forEach(function (k) {
        str = str.replace('{{' + k + '}}', data[k]);
      });
    }

    return str;
  }

  function wsCountText(n) {
    return n === 1 ? t('countOne') : t('countOther', { count: n });
  }

  /* ═══════════════════════════════════════
     CONFIG
  ═══════════════════════════════════════ */
  var REDIRECT_TO_CART_AFTER_ADD = false;
  var IMAGE_SIZE = 320;
  var QTY_KEY = 'ws_qty';
  var LOGIN_URL = '/account/login';

  function wsLocalizedPath(path) {
    var root = window.wsCurrentRootUrl || '/';

    if (typeof root !== 'string' || !root) root = '/';
    if (root === '/') return path;

    return root.replace(/\/$/, '') + '/' + String(path || '').replace(/^\/+/, '');
  }

  var EMPTY_STATE_CATEGORIES = [
    { label: t('emptyCatNewArrivals'), url: wsLocalizedPath('/collections/mens-sale-gianni-kavanagh') },
    { label: t('emptyCatSwimwear'),    url: wsLocalizedPath('/collections/swimwear') },
    { label: t('emptyCatTshirts'),     url: wsLocalizedPath('/collections/t-shirts') },
    { label: t('emptyCatJeans'),       url: wsLocalizedPath('/collections/jeans') },
    { label: t('emptyCatSets'),        url: wsLocalizedPath('/collections/mens-summer-sets-sale') },
    { label: t('emptyCatPolos'),       url: wsLocalizedPath('/collections/polos') }
  ];

  /* ═══════════════════════════════════════
     CACHE
  ═══════════════════════════════════════ */
  var _cache = null;
  var _fetchingNow = false;

  function _storeFetch(items) {
    _cache = { items: Array.isArray(items) ? items : [] };
    return _cache.items;
  }

  function _doFetch() {
    if (_fetchingNow) return Promise.resolve(_cache ? _cache.items : []);

    _fetchingNow = true;

    return wsGetItems()
      .then(_storeFetch)
      .catch(function () {
        return _cache ? _cache.items : [];
      })
      .then(function (items) {
        _fetchingNow = false;
        return items;
      });
  }

  function wsGetItemsCached() {
    if (_cache) return Promise.resolve(_cache.items);
    return wsGetItems().then(_storeFetch);
  }

  window.wsInvalidateCache = function () {
    _cache = null;
  };

  function wsStartPrefetch() {
    _doFetch().then(function (items) {
      updateWishlistCount(items.length);
    });

    setInterval(function () {
      _doFetch().then(function (items) {
        updateWishlistCount(items.length);
      });
    }, 60000);
  }

  /* ═══════════════════════════════════════
     UTILITÁRIOS
  ═══════════════════════════════════════ */
  function shopifyImageUrl(src, size) {
    if (!src || typeof src !== 'string') return src;

    size = size || IMAGE_SIZE;

    var clean = src
      .split('?')[0]
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|\d*x\d+)(\.[^.]+)$/, '$2');

    return clean.replace(/(\.[^.]+)$/, '_' + size + 'x$1');
  }

  function loadQtys() {
    try {
      return JSON.parse(localStorage.getItem(QTY_KEY) || '{}');
    } catch (_) {
      return {};
    }
  }

  function saveQty(variantId, qty) {
    if (!variantId) return;

    try {
      var all = loadQtys();
      all[String(variantId)] = qty;
      localStorage.setItem(QTY_KEY, JSON.stringify(all));
    } catch (_) {}
  }

  function getSavedQty(variantId) {
    var v = parseInt(loadQtys()[String(variantId)], 10);
    return v && v >= 1 ? v : 1;
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function wsGetCustomerId(item) {
    item = item || {};

    var value =
      item.customer_id ||
      window.wsWishlistCustomerId ||
      (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) ||
      (window.meta && window.meta.page && window.meta.page.customerId) ||
      '';

    if (value === null || value === undefined || value === false || value === '') return null;

    var str = String(value);

    if (str === 'null' || str === 'undefined' || str === '0') return null;

    return str;
  }

  function wsGetGuestId(item) {
    if (wsGetCustomerId(item)) return null;

    item = item || {};

    var value =
      item.guest_id ||
      window.wsWishlistGuestId ||
      getCookie('WISHLIST_UUID') ||
      null;

    return value ? String(value) : null;
  }

  function wsIsCustomerLoggedIn() {
    if (window.wsWishlistIsLoggedIn === true) return true;
    if (window.wsWishlistIsLoggedIn === false) return false;

    return !!wsGetCustomerId({});
  }

  function wsLoginUrlWithReturn() {
    var returnUrl = window.location.pathname + window.location.search;
    return LOGIN_URL + '?return_url=' + encodeURIComponent(returnUrl);
  }

  window.wsFormatPrice = function (cents) {
    if (cents == null || cents === '') return '';

    var n = parseInt(cents, 10);

    if (isNaN(n)) return '';

    return '\u20ac' + (n / 100).toFixed(2).replace('.', ',');
  };

  window.wsEscape = function (str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  };

  function cleanVariantText(text) {
    return String(text || '')
      .replace(/sold out|esgotado|indispon[íi]vel|unavailable|agotado/gi, '')
      .replace(/[()]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function wsCssAttr(value) {
    if (window.CSS && CSS.escape) return CSS.escape(String(value || ''));

    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
  }

  function wsSameItem(a, b) {
    if (!a || !b) return false;

    return (
      (a.item_id && b.item_id && String(a.item_id) === String(b.item_id)) ||
      (a.variant_id && b.variant_id && String(a.variant_id) === String(b.variant_id)) ||
      (a.id && b.id && String(a.id) === String(b.id)) ||
      (a.handle && b.handle && String(a.handle) === String(b.handle))
    );
  }

  function wsNormalizeItem(item, card) {
    if (item && typeof item === 'object') {
      return {
        item_id:     item.item_id || '',
        id:          item.id || item.product_id || '',
        handle:      item.handle || item.product_handle || '',
        variant_id:  item.variant_id || '',
        customer_id: item.customer_id || '',
        guest_id:    item.guest_id || ''
      };
    }

    return {
      id:          item || (card ? card.getAttribute('data-product-id') : ''),
      item_id:     card ? card.getAttribute('data-item-id') : '',
      handle:      card ? card.getAttribute('data-product-handle') : '',
      variant_id:  card ? card.getAttribute('data-variant-id') : '',
      customer_id: '',
      guest_id:    ''
    };
  }

  /* ═══════════════════════════════════════
     TOAST LOGIN
  ═══════════════════════════════════════ */
  function wsInjectLoginToastStyles() {
    if (document.getElementById('ws-login-required-toast-style')) return;

    var style = document.createElement('style');
    style.id = 'ws-login-required-toast-style';

    style.textContent =
      '.ws-login-required-toast{' +
        'position:fixed;' +
        'top:24px;' +
        'left:50%;' +
        'z-index:999999;' +
        'display:flex;' +
        'align-items:center;' +
        'gap:14px;' +
        'max-width:calc(100vw - 32px);' +
        'padding:14px 18px;' +
        'background:#111;' +
        'color:#fff;' +
        'font-size:14px;' +
        'line-height:1.4;' +
        'border-radius:999px;' +
        'box-shadow:0 8px 28px rgba(0,0,0,.18);' +
        'transform:translate(-50%,-16px);' +
        'opacity:0;' +
        'pointer-events:none;' +
        'transition:opacity .25s ease,transform .25s ease;' +
      '}' +
      '.ws-login-required-toast.ws-visible{' +
        'opacity:1;' +
        'transform:translate(-50%,0);' +
        'pointer-events:auto;' +
      '}' +
      '.ws-login-required-toast a{' +
        'color:#fff;' +
        'font-weight:700;' +
        'text-decoration:underline;' +
        'white-space:nowrap;' +
      '}' +
      '@media screen and (max-width:749px){' +
        '.ws-login-required-toast{' +
          'top:16px;' +
          'width:calc(100vw - 32px);' +
          'justify-content:space-between;' +
          'border-radius:14px;' +
        '}' +
      '}';

    document.head.appendChild(style);
  }

  function wsShowLoginRequiredMessage() {
    wsInjectLoginToastStyles();

    document.querySelectorAll('.ws-login-required-toast').forEach(function (el) {
      el.remove();
    });

    var toast = document.createElement('div');
    toast.className = 'ws-login-required-toast';
    toast.setAttribute('role', 'alert');

    toast.innerHTML =
      '<span>' + wsEscape(t('loginRequired')) + '</span>' +
      '<a href="' + wsEscape(wsLoginUrlWithReturn()) + '">' + wsEscape(t('loginRequiredButton')) + '</a>';

    document.body.appendChild(toast);

    setTimeout(function () {
      toast.classList.add('ws-visible');
    }, 10);

    setTimeout(function () {
      toast.classList.remove('ws-visible');

      setTimeout(function () {
        toast.remove();
      }, 250);
    }, 4500);
  }

  /* ═══════════════════════════════════════
     ATUALIZAR CONTADORES
  ═══════════════════════════════════════ */
  function updateWishlistCount(count) {
    var safeCount = Math.max(0, parseInt(count, 10) || 0);
    var countEl = document.getElementById('ws-count');

    if (countEl) countEl.textContent = wsCountText(safeCount);

    document.querySelectorAll('.wh-count').forEach(function (el) {
      el.textContent = safeCount;
      el.style.display = safeCount > 0 ? 'flex' : 'none';
    });
  }

  /* ═══════════════════════════════════════
     RESET / ATIVAR BOTÕES
  ═══════════════════════════════════════ */
  function _resetWishlistBtn(btn) {
    if (!btn) return;

    btn.setAttribute('data-wishlisted', 'false');
    btn.setAttribute('data-is-added', 'false');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Add to wishlist');

    btn.classList.remove('is-wishlisted', 'wishlisted', 'active', 'is-added', 'added');

    btn.querySelectorAll('path, svg').forEach(function (el) {
      el.removeAttribute('style');
      el.removeAttribute('fill');
      el.removeAttribute('stroke');
    });
  }

  function _activateWishlistBtn(btn) {
    if (!btn) return;

    btn.setAttribute('data-wishlisted', 'true');
    btn.setAttribute('data-is-added', 'true');
    btn.setAttribute('aria-pressed', 'true');
    btn.setAttribute('aria-label', 'Remove from wishlist');
  }

  /* ═══════════════════════════════════════
     REFRESH UI
  ═══════════════════════════════════════ */
  function wsRefreshWishlistUI(delay) {
    setTimeout(function () {
      window.wsInvalidateCache();

      wsGetItems().then(function (items) {
        _storeFetch(items);
        updateWishlistCount(items.length);

        var body = document.getElementById('ws-body');
        var countEl = document.getElementById('ws-count');
        var sidebar = document.getElementById('ws-sidebar');
        var sidebarOpen = sidebar && sidebar.classList.contains('ws-open');

        if (sidebarOpen && body) {
          _renderItems(items, body, countEl);
        }
      });
    }, typeof delay === 'number' ? delay : 0);
  }

  function wsExtractCustomerId(doc, html, itemEl) {
    var fromItem = itemEl && (itemEl.dataset.customerId || itemEl.getAttribute('data-customer-id'));

    if (fromItem) return String(fromItem);

    var customerNode = doc.querySelector('[data-customer-id]');

    if (customerNode) {
      var fromNode = customerNode.dataset.customerId || customerNode.getAttribute('data-customer-id');

      if (fromNode) return String(fromNode);
    }

    var fromWindow = wsGetCustomerId({});

    if (fromWindow) return String(fromWindow);

    var match = String(html || '').match(/customerId["']?\s*[:=]\s*["']?(\d+)/i);

    if (match && match[1]) return String(match[1]);

    return '';
  }

  /* ═══════════════════════════════════════
     ABRIR / FECHAR SIDEBAR
  ═══════════════════════════════════════ */
  window.wsOpen = function () {
    var sidebar = document.getElementById('ws-sidebar');

    if (!sidebar) return;

    sidebar.classList.add('ws-open');
    document.body.style.overflow = '';

    window.wsInvalidateCache();
    wsRender(true);
  };

  window.wsClose = function () {
    var sidebar = document.getElementById('ws-sidebar');

    if (!sidebar) return;

    sidebar.classList.remove('ws-open');
  };

  /* ═══════════════════════════════════════
     EXTRAIR DADOS DA WISHLISTSUITE
  ═══════════════════════════════════════ */
  function wsGetUniqueVariantOptions(el) {
    var optionEls = Array.from(el.querySelectorAll('.wls-list-col-variant select option'));

    if (!optionEls.length) {
      optionEls = Array.from(el.querySelectorAll('.wls-variant-select option'));
    }

    var seenVariantIds = {};

    return optionEls.filter(function (opt) {
      var vid = String(opt.value || '').trim();

      if (!vid || seenVariantIds[vid]) return false;

      seenVariantIds[vid] = true;

      return true;
    });
  }

  window.wsGetItems = function () {
    return fetch('/apps/api/list', {
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('WishlistSuite response error');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        return Array.from(doc.querySelectorAll('.wls-list-item')).map(function (el) {
          var sel =
            el.querySelector('.wls-list-col-variant select option:checked') ||
            el.querySelector('.wls-variant-select option:checked');

          var image = el.querySelector('.wls-list-product-image img');
          var title = el.querySelector('.wls-list-product-title');
          var link  = el.querySelector('.wls-list-product-link');

          var rawSrc = image ? (image.getAttribute('data-src') || image.getAttribute('src') || '') : '';
          var variantOptions = wsGetUniqueVariantOptions(el);

          var variants = variantOptions.map(function (opt) {
            return {
              id:        opt.value,
              title:     opt.textContent.trim(),
              price:     parseInt(opt.dataset.priceRaw || el.dataset.priceRaw || 0, 10),
              available: opt.dataset.available !== 'false'
            };
          });

          return {
            item_id:          el.dataset.itemId || el.getAttribute('data-item-id') || '',
            id:               el.dataset.productId || el.getAttribute('data-product-id') || '',
            handle:           el.dataset.productHandle || el.getAttribute('data-product-handle') || '',
            customer_id:      wsExtractCustomerId(doc, html, el),
            guest_id:         el.dataset.guestId || el.getAttribute('data-guest-id') || '',
            title:            title ? title.textContent.trim() : '',
            image:            shopifyImageUrl(rawSrc, IMAGE_SIZE),
            url:              link ? link.getAttribute('href') : '',
            price:            el.dataset.priceRaw || el.getAttribute('data-price-raw') || '',
            compare_at_price: sel ? sel.dataset.comparePrice || '' : '',
            variant_id:       sel ? sel.value : '',
            variants:         variants
          };
        });
      })
      .catch(function (err) {
        console.error('[WishlistSuite] erro:', err);
        return [];
      });
  };

  /* ═══════════════════════════════════════
     ENRIQUECIMENTO LAZY
  ═══════════════════════════════════════ */
  window.wsEnrichProduct = function (item) {
    var hasImage    = item.image && String(item.image).length > 4;
    var hasVariants = item.variants && item.variants.length > 0;
    var hasPrice    = item.price != null && item.price !== '';

    if (hasImage && hasVariants && hasPrice) return Promise.resolve(item);

    var handle = item.handle || '';

    if (!handle) return Promise.resolve(item);

    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(function (p) {
        var rawImg = p.featured_image || (p.images && p.images[0]) || '';

        return {
          item_id:          item.item_id || '',
          id:               item.id || p.id,
          handle:           item.handle || p.handle,
          customer_id:      item.customer_id || '',
          guest_id:         item.guest_id || '',
          title:            item.title || p.title,
          image:            hasImage ? item.image : shopifyImageUrl(rawImg, IMAGE_SIZE),
          price:            hasPrice ? item.price : p.price,
          compare_at_price: item.compare_at_price || p.compare_at_price,
          variant_id:       item.variant_id || (p.variants && p.variants[0] ? p.variants[0].id : ''),
          variants:         hasVariants ? item.variants : (p.variants || []),
          url:              item.url || p.url
        };
      })
      .catch(function () {
        return item;
      });
  };

  /* ═══════════════════════════════════════
     CARRINHO
  ═══════════════════════════════════════ */
  function updateCartBubble(count) {
    var safeCount = Math.max(0, parseInt(count, 10) || 0);

    document.querySelectorAll(
      '.header__cart-count, .header__cart-count--floating, .bubble-count, cart-count'
    ).forEach(function (el) {
      el.setAttribute('data-cart-count', safeCount);
      el.textContent = safeCount;
    });

    document.dispatchEvent(new CustomEvent('cart:count:update', {
      bubbles: true,
      detail: { count: safeCount }
    }));
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var count = cart.item_count || 0;

        updateCartBubble(count);

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart-update',  { bubbles: true, detail: { cart: cart } }));

        return cart;
      })
      .catch(function (e) {
        console.warn('[WishlistSuite] erro carrinho:', e);
      });
  }

  /* ═══════════════════════════════════════
     VARIANTES
  ═══════════════════════════════════════ */
  function buildVariantGrid(variants, currentVariantId, onSelect) {
    var grid = document.createElement('div');
    grid.className = 'ws-variant-grid';

    variants.forEach(function (v) {
      var btn = document.createElement('button');

      btn.type = 'button';
      btn.textContent = cleanVariantText(v.title).split('/')[0].trim();
      btn.dataset.variantId = v.id;

      if (String(v.id) === String(currentVariantId)) {
        btn.classList.add('ws-active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.setAttribute('aria-pressed', 'false');
      }

      if (v.available === false) {
        btn.classList.add('ws-sold-out');
        btn.disabled = true;
      }

      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        grid.querySelectorAll('button').forEach(function (b) {
          b.classList.remove('ws-active');
          b.setAttribute('aria-pressed', 'false');
        });

        btn.classList.add('ws-active');
        btn.setAttribute('aria-pressed', 'true');

        if (onSelect) onSelect(v);
      });

      grid.appendChild(btn);
    });

    return grid;
  }

  /* ═══════════════════════════════════════
     QUANTIDADE
  ═══════════════════════════════════════ */
  function buildQtyStepper(initialQty, onChange) {
    var wrapper = document.createElement('div');
    wrapper.className = 'ws-qty-wrapper';

    var label = document.createElement('span');
    label.className = 'ws-qty-label';
    label.textContent = t('qty');

    var stepper = document.createElement('div');
    stepper.className = 'ws-qty-stepper';

    var btnMinus = document.createElement('button');
    btnMinus.type = 'button';
    btnMinus.className = 'ws-qty-step ws-qty-minus';
    btnMinus.setAttribute('aria-label', t('qtyDecrease'));
    btnMinus.textContent = '\u2212';

    var input = document.createElement('input');
    input.type = 'number';
    input.className = 'ws-qty-input';
    input.min = '1';
    input.step = '1';
    input.value = initialQty;
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('aria-label', 'Quantidade');

    var btnPlus = document.createElement('button');
    btnPlus.type = 'button';
    btnPlus.className = 'ws-qty-step ws-qty-plus';
    btnPlus.setAttribute('aria-label', t('qtyIncrease'));
    btnPlus.textContent = '+';

    btnMinus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;

      if (onChange) onChange(v);
    });

    btnPlus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;

      if (onChange) onChange(v);
    });

    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);

      if (!v || v < 1) {
        v = 1;
        input.value = 1;
      }

      if (onChange) onChange(v);
    });

    stepper.appendChild(btnMinus);
    stepper.appendChild(input);
    stepper.appendChild(btnPlus);

    wrapper.appendChild(label);
    wrapper.appendChild(stepper);

    wrapper._getQty = function () {
      return parseInt(input.value, 10) || 1;
    };

    return wrapper;
  }

  /* ═══════════════════════════════════════
     CARD
  ═══════════════════════════════════════ */
  function buildCard(item) {
    var card = document.createElement('div');

    card.className = 'ws-card';
    card.setAttribute('data-item-id', item.item_id || '');
    card.setAttribute('data-product-id', item.id || '');
    card.setAttribute('data-product-handle', item.handle || '');
    card.setAttribute('data-variant-id', item.variant_id || '');

    var variants = item.variants || [];

    var activeVariant = variants.length > 0
      ? (variants.find(function (v) { return String(v.id) === String(item.variant_id); }) || variants[0])
      : null;

    var activeVariantId = activeVariant ? activeVariant.id : (item.variant_id || item.id);

    var imgSrc = (typeof item.image === 'object' && item.image)
      ? (item.image.src || item.image.url || '')
      : (item.image || '');

    imgSrc = shopifyImageUrl(imgSrc, IMAGE_SIZE);

    var imgEl = document.createElement('img');
    imgEl.className = 'ws-card-img';
    imgEl.src = imgSrc;
    imgEl.alt = item.title || '';
    imgEl.width = IMAGE_SIZE;
    imgEl.decoding = 'async';

    imgEl.onerror = function () {
      this.style.background = '#f0ede8';
      this.removeAttribute('src');
    };

    card.appendChild(imgEl);

    var info = document.createElement('div');
    info.className = 'ws-card-info';

    var nameEl = document.createElement('a');
    nameEl.className = 'ws-card-name';
    nameEl.href = item.url || ('/products/' + (item.handle || ''));
    nameEl.title = item.title || '';
    nameEl.textContent = item.title || '';
    info.appendChild(nameEl);

    var priceEl = document.createElement('p');
    priceEl.className = 'ws-card-price';

    var price = parseInt(item.price || 0, 10);
    var compare = parseInt(item.compare_at_price || 0, 10);

    var compareHtml = compare && compare > price
      ? '<span class="ws-card-compare">' + wsFormatPrice(compare) + '</span>'
      : '';

    priceEl.innerHTML = wsEscape(wsFormatPrice(price)) + compareHtml;
    info.appendChild(priceEl);

    var qtyStepper;

    if (variants.length > 1) {
      var grid = buildVariantGrid(variants, activeVariantId, function (v) {
        activeVariantId = v.id;

        if (qtyStepper) saveQty(v.id, qtyStepper._getQty());

        if (v.price != null) {
          priceEl.textContent = wsFormatPrice(v.price);
        }
      });

      info.appendChild(grid);
    } else if (variants.length === 1) {
      var hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.className = 'ws-active-variant-id';
      hiddenInput.value = variants[0].id;
      info.appendChild(hiddenInput);
    }

    var atcRow = document.createElement('div');
    atcRow.className = 'ws-atc-row';

    qtyStepper = buildQtyStepper(getSavedQty(activeVariantId), function (newQty) {
      saveQty(activeVariantId, newQty);
    });

    atcRow.appendChild(qtyStepper);

    var atcBtn = document.createElement('button');
    atcBtn.type = 'button';
    atcBtn.className = 'ws-btn-atc';
    atcBtn.textContent = t('addToCart');

    atcBtn.addEventListener('click', function () {
      var varId = null;
      var activeBtn = info.querySelector('.ws-variant-grid button.ws-active');

      if (activeBtn) varId = activeBtn.dataset.variantId;

      if (!varId) {
        var h = info.querySelector('.ws-active-variant-id');
        if (h) varId = h.value;
      }

      if (!varId) varId = activeVariantId || item.variant_id || item.id;

      wsAddVariantToCart(card, atcBtn, varId, qtyStepper._getQty());
    });

    atcRow.appendChild(atcBtn);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'ws-btn-remove';
    removeBtn.setAttribute('aria-label', t('remove'));

    removeBtn.innerHTML =
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false">' +
        '<line x1="18" y1="6" x2="6" y2="18"></line>' +
        '<line x1="6" y1="6" x2="18" y2="18"></line>' +
      '</svg>';

    removeBtn.addEventListener('click', function () {
      wsRemoveCard(card, item);
    });

    atcRow.appendChild(removeBtn);
    info.appendChild(atcRow);

    var errorEl = document.createElement('p');
    errorEl.className = 'ws-card-error';
    info.appendChild(errorEl);

    card.appendChild(info);

    return card;
  }

  /* ═══════════════════════════════════════
     ADICIONAR AO CARRINHO
  ═══════════════════════════════════════ */
  function wsAddVariantToCart(card, btn, variantId, quantity) {
    var originalText = btn.textContent;

    btn.textContent = '...';
    btn.disabled = true;
    btn.classList.add('ws-atc-loading');

    var errorEl = card.querySelector('.ws-card-error');

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity
      })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (e) {
            throw e;
          });
        }

        return r.json();
      })
      .then(function () {
        if (REDIRECT_TO_CART_AFTER_ADD) {
          window.location.href = '/cart';
          return;
        }

        return refreshCartCount().then(function () {
          btn.classList.remove('ws-atc-loading');
          btn.classList.add('ws-atc-success');
          btn.textContent = t('added');

          setTimeout(function () {
            btn.classList.remove('ws-atc-success');
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        });
      })
      .catch(function (error) {
        var rawMsg = error && (error.description || error.message)
          ? String(error.description || error.message)
          : '';

        var isSoldOut = /sold out|esgotado|unavailable|indispon/i.test(rawMsg);
        var msg = (!isSoldOut && rawMsg) ? rawMsg : t('errorGeneric');

        if (errorEl) {
          errorEl.textContent = msg;
          errorEl.style.display = '';
        }

        btn.classList.remove('ws-atc-loading');
        btn.textContent = t('error');

        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;

          if (errorEl) {
            errorEl.textContent = '';
            errorEl.style.display = 'none';
          }
        }, 2000);
      });
  }

  /* ═══════════════════════════════════════
     REMOVER DA WISHLIST
  ═══════════════════════════════════════ */
  function wsRemoveFromWishlistSuite(item) {
    if (!item || !item.item_id) {
      console.warn('[WishlistSuite] item_id em falta:', item);
      return Promise.resolve(false);
    }

    var customerId = wsGetCustomerId(item);
    var guestId = wsGetGuestId(item);

    return fetch('/apps/api/wishlists', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        itemId:     item.item_id,
        action:     'remove',
        customerId: customerId,
        guestId:    guestId
      })
    })
      .then(function (res) {
        if (!res.ok) {
          console.warn('[WishlistSuite] erro ao remover:', res.status);
          return false;
        }

        return res.json().catch(function () {
          return {};
        });
      })
      .then(function (data) {
        return data !== false;
      })
      .catch(function (err) {
        console.warn('[WishlistSuite] erro no pedido de remoção:', err);
        return false;
      });
  }

  function wsUpdateWishlistButtons(item) {
    var selectors = [];

    if (item.variant_id) {
      selectors.push('.product-card-wishlist-btn[data-variant-id="' + wsCssAttr(item.variant_id) + '"]');
      selectors.push('.wishlist-trigger[data-variant-id="' + wsCssAttr(item.variant_id) + '"]');
      selectors.push('wishlist-button[data-variant-id="' + wsCssAttr(item.variant_id) + '"]');
    }

    if (item.id) {
      selectors.push('.product-card-wishlist-btn[data-product-id="' + wsCssAttr(item.id) + '"]');
      selectors.push('.wishlist-trigger[data-product-id="' + wsCssAttr(item.id) + '"]');
      selectors.push('wishlist-button[data-product-id="' + wsCssAttr(item.id) + '"]');
    }

    if (item.handle) {
      selectors.push('.product-card-wishlist-btn[data-product-handle="' + wsCssAttr(item.handle) + '"]');
      selectors.push('.wishlist-trigger[data-product-handle="' + wsCssAttr(item.handle) + '"]');
      selectors.push('wishlist-button[data-product-handle="' + wsCssAttr(item.handle) + '"]');
    }

    function _applyReset() {
      selectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (btn) {
          _resetWishlistBtn(btn);
        });
      });
    }

    _applyReset();
    setTimeout(_applyReset, 300);
    setTimeout(_applyReset, 800);
    setTimeout(_applyReset, 1500);
  }

  function wsCleanLocalWishlistStorage(item) {
    try {
      Object.keys(localStorage).forEach(function (key) {
        if (!key.toLowerCase().includes('wish') || key === QTY_KEY) return;

        var value = localStorage.getItem(key);

        if (!value) return;

        var parsed = JSON.parse(value);

        if (!Array.isArray(parsed)) return;

        parsed = parsed.filter(function (i) {
          return (
            String(i.id || i.product_id || '') !== String(item.id || '') &&
            String(i.item_id || '') !== String(item.item_id || '') &&
            String(i.variant_id || i.variantId || '') !== String(item.variant_id || '') &&
            String(i.handle || i.product_handle || '') !== String(item.handle || '')
          );
        });

        localStorage.setItem(key, JSON.stringify(parsed));
      });
    } catch (_) {}
  }

  function wsRemoveCard(card, itemData) {
    var item = wsNormalizeItem(itemData, card);
    var removeBtn = card.querySelector('.ws-btn-remove');
    var errorEl = card.querySelector('.ws-card-error');

    if (removeBtn) {
      removeBtn.disabled = true;
      removeBtn.style.opacity = '0.4';
      removeBtn.style.pointerEvents = 'none';
    }

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }

    wsRemoveFromWishlistSuite(item).then(function (removed) {
      if (!removed) {
        if (removeBtn) {
          removeBtn.disabled = false;
          removeBtn.style.opacity = '';
          removeBtn.style.pointerEvents = '';
        }

        if (errorEl) {
          errorEl.textContent = 'Não foi possível remover este artigo da wishlist.';
          errorEl.style.display = '';
        }

        return;
      }

      if (_cache) {
        _cache.items = _cache.items.filter(function (i) {
          return !wsSameItem(i, item);
        });
      }

      wsUpdateWishlistButtons(item);
      wsCleanLocalWishlistStorage(item);

      card.style.transition = 'opacity 0.2s, transform 0.2s';
      card.style.opacity = '0';
      card.style.transform = 'translateX(20px)';

      setTimeout(function () {
        card.remove();

        var remaining = _cache
          ? _cache.items.length
          : document.querySelectorAll('#ws-body .ws-card').length;

        updateWishlistCount(remaining);

        if (remaining === 0) showEmptyState();
      }, 220);
    });
  }

  /* ═══════════════════════════════════════
     ESTADO VAZIO
  ═══════════════════════════════════════ */
  function showEmptyState() {
    var body = document.getElementById('ws-body');

    if (!body) return;

    body.querySelectorAll('#ws-empty').forEach(function (el) {
      el.remove();
    });

    var wrapper = document.createElement('div');
    wrapper.id = 'ws-empty';

    wrapper.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" fill="none" stroke="currentColor" stroke-width="1.25"><path d="M20.583 22.75 13 17.333 5.417 22.75V5.417A2.167 2.167 0 0 1 7.583 3.25h10.834a2.167 2.167 0 0 1 2.166 2.167V22.75Z"/></svg>' +
      '<p class="ws-empty-title">' + t('emptyTitle') + '</p>' +
      '<p class="ws-empty-subtitle">' + t('emptySubtitle') + '</p>';

    var catsEl = document.createElement('div');
    catsEl.className = 'ws-empty-cats';

    EMPTY_STATE_CATEGORIES.forEach(function (cat) {
      var a = document.createElement('a');
      a.className = 'ws-empty-cat';
      a.href = cat.url;
      a.textContent = cat.label;
      catsEl.appendChild(a);
    });

    wrapper.appendChild(catsEl);
    body.appendChild(wrapper);
  }

  /* ═══════════════════════════════════════
     RENDER
  ═══════════════════════════════════════ */
  window.wsRender = function (forceFresh) {
    var body = document.getElementById('ws-body');
    var countEl = document.getElementById('ws-count');

    if (!body) return;

    if (!forceFresh && _cache) {
      _renderItems(_cache.items, body, countEl);
      return;
    }

    body.innerHTML = '<div id="ws-loading"><div class="ws-spinner"></div></div>';

    window.wsInvalidateCache();

    wsGetItems().then(function (items) {
      _storeFetch(items);
      _renderItems(items, body, countEl);
    });
  };

  function _renderItems(rawItems, body, countEl) {
    var items = Array.isArray(rawItems) ? rawItems : [];

    body.innerHTML = '';

    if (countEl) countEl.textContent = wsCountText(items.length);

    updateWishlistCount(items.length);

    if (!items.length) {
      showEmptyState();
      return;
    }

    var needsEnrich = [];

    items.forEach(function (item) {
      var card = buildCard(item);
      body.appendChild(card);

      var missing =
        !item.image ||
        !item.variants ||
        item.variants.length === 0 ||
        item.price == null ||
        item.price === '';

      if (missing) {
        needsEnrich.push({
          card: card,
          item: item
        });
      }
    });

    if (!needsEnrich.length) return;

    Promise.all(needsEnrich.map(function (entry) {
      return wsEnrichProduct(entry.item).then(function (enriched) {
        if (_cache) {
          _cache.items = _cache.items.map(function (i) {
            return wsSameItem(i, enriched) ? enriched : i;
          });
        }

        if (entry.card.parentNode) {
          entry.card.replaceWith(buildCard(enriched));
        }
      });
    }));
  }

  /* ═══════════════════════════════════════
     PARTILHAR WISHLIST
  ═══════════════════════════════════════ */
  window.wsShare = function () {
    var url = window.location.origin + '/apps/api/list';

    if (navigator.share) {
      navigator.share({
        title: t('shareTitle'),
        url: url
      });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var btn = document.getElementById('ws-share-btn');

        if (!btn) return;

        var orig = btn.innerHTML;
        btn.textContent = t('shareLinkCopied');

        setTimeout(function () {
          btn.innerHTML = orig;
        }, 2000);
      });
    }
  };

  /* ═══════════════════════════════════════
     LISTENER BOTÕES EXTERNOS DE WISHLIST
  ═══════════════════════════════════════ */
  function bindExternalWishlistListener() {
    /*
      Listener em capture:
      só bloqueia visitantes antes da WishlistSuite processar o clique.
      Para clientes logados, não interfere.
    */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.wishlist-trigger, wishlist-button, .product-card-wishlist-btn');

      if (!btn) return;
      if (btn.closest('#ws-sidebar')) return;

      if (wsIsCustomerLoggedIn()) {
        return;
      }

      var isCurrentlyWishlisted =
        btn.getAttribute('data-wishlisted') === 'true' ||
        btn.getAttribute('data-is-added') === 'true';

      var willBeWishlisted = !isCurrentlyWishlisted;

      if (willBeWishlisted) {
        e.preventDefault();
        e.stopPropagation();

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }

        _resetWishlistBtn(btn);
        wsShowLoginRequiredMessage();

        return false;
      }
    }, true);

    /*
      Listener normal:
      depois do clique da WishlistSuite, apenas atualiza contador/sidebar.
      Não altera o botão.
    */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.wishlist-trigger, wishlist-button, .product-card-wishlist-btn');

      if (!btn) return;
      if (btn.closest('#ws-sidebar')) return;
      if (!wsIsCustomerLoggedIn()) return;

      window.wsInvalidateCache();

      wsRefreshWishlistUI(700);
      wsRefreshWishlistUI(1400);
      wsRefreshWishlistUI(2400);
    }, false);
  }

  /* ═══════════════════════════════════════
     INIT
  ═══════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    wsInjectLoginToastStyles();

    document.querySelectorAll('.wh-trigger').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        wsOpen();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') wsClose();
    });

    wsStartPrefetch();
    bindExternalWishlistListener();
  });

  setTimeout(refreshCartCount, 600);

})();


// Bydas regularizar nome de add to wishlist pop up


function formatWishlistToastName(text) {
  return String(text || '')
    .trim()
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/(^|\s)([a-zà-ÿ])/g, function (match) {
      return match.toUpperCase();
    });
}

function updateWishlistToastNames(root) {
  root = root || document;

  root.querySelectorAll('.wishlist-toast-product-name').forEach(function (el) {
    if (el.dataset.formatted === 'true') return;

    el.textContent = formatWishlistToastName(el.textContent);
    el.dataset.formatted = 'true';
  });
}

updateWishlistToastNames(document);

var wishlistToastObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return;

      if (node.classList && node.classList.contains('wishlist-toast-product-name')) {
        node.textContent = formatWishlistToastName(node.textContent);
        node.dataset.formatted = 'true';
      } else {
        updateWishlistToastNames(node);
      }
    });
  });
});

wishlistToastObserver.observe(document.body, {
  childList: true,
  subtree: true
});